module.exports = __webpack_public_path__ + "img/398-0ce6e1.png";